export { Search2 as default } from './Search2';
